import { defineMessages } from 'react-intl';

export const bypassBlockMessages = defineMessages({
  gridFilterValueList: {
    id: 'gridFilter.valueList.bypass.headline',
    defaultMessage: 'Filteroptionen zu Filter {filterName} überspringen',
  },
  gridFilterValueGroup: {
    id: 'gridFilter.valueGroup.bypass.headline',
    defaultMessage: '{filterGroupName} überspringen',
  },
});
